import { render } from "./MRedemptionButtonSection.vue?vue&type=template&id=44a87f81&scoped=true&ts=true"
import script from "./MRedemptionButtonSection.vue?vue&type=script&lang=ts"
export * from "./MRedemptionButtonSection.vue?vue&type=script&lang=ts"

import "./MRedemptionButtonSection.vue?vue&type=style&index=0&id=44a87f81&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a87f81"]])

export default __exports__